'use es6';

import { Map as ImmutableMap } from 'immutable';
const detailsStateSelector = state => state.getIn(['details', 'emailChildSelect'], ImmutableMap({}));
export default detailsStateSelector;